import { useEffect, useState } from "react";
interface Props {
  formId: string;
    navigateToConfirmationPage: () => void;
    showSurchargeCheckoutForm: boolean;
}

export const CreditCardForm = ({
  formId,
    navigateToConfirmationPage,
    showSurchargeCheckoutForm,
}: Props) => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      // Validate where the message is coming from
      if (event.origin !== process.env.REACT_APP_BASE_URL) {
        console.warn(
          "Received message from unauthorized origin:",
          event.origin
        );
        return;
      }

      // Validate message and nevigate to confirmation page
      const message = event.data;
      if (Array.isArray(message) && message[0] === "Transaction Accepted") {
        navigateToConfirmationPage();
      } else {
        console.warn(
          "Validation Message is not valid or not accepted",
          message
        );
      }
    };

    // Add the event listener
    window.addEventListener("message", handleMessage);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

    if (showSurchargeCheckoutForm) {
        return (
            <>
                <iframe
                    title="firstMileCreditCardForm"
                    id="firstMileForm"
                    src={`${process.env.REACT_APP_CHECKOUT_SURCHARGE_FORM}?${formId}&hostUrl=${window.location.origin}`}
                    referrerPolicy="origin"
                    className="ta-h-[234px]"
                ></iframe>
            </>
        );
     } else { 
        return (
            <>
                <iframe
                    title="firstMileCreditCardForm"
                    id="firstMileForm"
                    src={`${process.env.REACT_APP_CHECKOUT_FORM}?${formId}&hostUrl=${window.location.origin}`}
                    referrerPolicy="origin"
                    className="ta-h-[234px]"
                ></iframe>
            </>
        );
    }

};
